import { Box, Grid2 } from "@mui/material";
import React, { useRef, useState, useEffect, useCallback } from "react";
import useResponsive from "../../shared/utils/Responsive";
import { NavigationArrows } from "../../feature/Home/LatestCourses";
import Heading from "../utils/Heading";

const HorizontalScroll = ({ children, heading, subheading, size }) => {
    const isSmallScreen = useResponsive("md");
    const scrollRef = useRef(null);
    const [activeIndex, setActiveIndex] = useState(0);
    const actualSize = (isSmallScreen ? 1 : size) * 1.05;
    const scroll = useCallback((direction) => {
        if (scrollRef.current?.children.length > 0) {
            const cardWidth = scrollRef.current.children[0].offsetWidth * actualSize;
            scrollRef.current.scrollBy({
                left: direction === "left" ? -cardWidth : cardWidth,
                behavior: "smooth",
            });
        }
    }, []);
    useEffect(() => {
        const handleScroll = () => {
            if (scrollRef.current) {
                const scrollLeft = scrollRef.current.scrollLeft;
                const cardWidth = scrollRef.current.children[0]?.offsetWidth * actualSize;
                const newIndex = Math.round(scrollLeft / cardWidth);
                setActiveIndex(newIndex);
            }
        };

        const ref = scrollRef.current;
        if (ref) {
            ref.addEventListener("scroll", handleScroll);
            return () => ref.removeEventListener("scroll", handleScroll);
        }
    }, [actualSize]);

    const totalPages = Math.ceil(React.Children.count(children) / actualSize) || 1;



    return (
        <>
            <Heading
                Heading={heading}
                SubHeading={subheading}
                RightContent={
                    <NavigationArrows
                        leftHandleClick={() => scroll("left")}
                        rightHandleClick={() => scroll("right")}
                    />

                }
            />
            <Grid2 container ref={scrollRef} sx={styles.scrollContainer}>
                {children}
            </Grid2>
            <Box sx={styles.dotsContainer}>
                {Array.from({ length: totalPages }).map((_, index) => (
                    <Box
                        key={index}
                        sx={{
                            ...styles.dot,
                            backgroundColor: activeIndex === index ? "#FF0000" : "#D9D9D9",
                        }}
                    />
                ))}
            </Box>

        </>
    );
};

const styles = {
    scrollContainer: {
        overflowX: "auto",
        display: "flex",
        flexWrap: "nowrap",
        gap: "30px",
        scrollbarWidth: "none",
        "&::-webkit-scrollbar": { display: "none" },
        scrollBehavior: "smooth",
    },
    dotsContainer: {
        display: "flex",
        justifyContent: "center",
        mt: 4,
    },
    dot: {
        width: 12,
        height: 12,
        borderRadius: "50%",
        margin: "0 3px",
        transition: "background-color 0.3s ease",
    },
};

export default HorizontalScroll;
